// Core packages
import { NgModule } from '@angular/core';

// Third party packages

// Custom packages - Modules
import { GasMetersRoutingModule } from './gas-meters-routing.module';
// import { PublicModule } from 'src/app/modules/public/public.module';
import { SharedModule } from '../shared.module';

// Custom packages - Components
import { GasMetersListComponent } from 'src/app/modules/gas-meters/pages/gas-meters-list/gas-meters-list.page';

@NgModule({
  imports: [
    // Shared modules
    SharedModule,

    // Custom
    GasMetersRoutingModule,
    // PublicModule,
  ],
  declarations: [
    GasMetersListComponent,
  ],
  entryComponents: [
  ],
  exports: [
  ]
})
export class GasMetersModule { }
